const actions = {
  SET_STATE: 'menu/SET_STATE',
  SET_DATA: 'menu/SET_DATA',
}

export default actions
